<template>
  <div class="generate-link" v-if="data.displayName">
    <div class="info">
      <div class="text">
        <div class="title weight-600">{{data.displayName}}</div>
        <div class="category weight-500">{{data.categories}}</div>
        <div class="address">{{data.streetAddress}}</div>
      </div>
      <img :alt="data.displayName" class="image" :src="data.photo.smallUrl" />
    </div>
    <div class="copy-container">
      <div class="title">สำหรับช่องทาง LINE Official Account</div>
      <div class="url-container">
        <div class="url volte weight-500">
          <textarea rows="1" disabled>{{data.links.liff}}</textarea>
        </div>
        <div 
          class="button volte weight-600 desktop-only"
          v-on:click="copyLink('liff')"
        >Copy</div>
      </div>
      <div 
        class="button volte weight-600 mobile-only"
        v-on:click="copyLink('liff')"
      >Copy</div>
      <a 
        class="link green" 
        target="_blank" 
        rel="noopener noreferrer"
        href="https://lineforbusiness.com/richmenumaker?utm_source=lineman-sellers"
      >วิธีสร้างริชเมนู (RICH MENU)</a>
      <a 
        class="link green" 
        target="_blank" 
        rel="noopener noreferrer"
        href="https://lineman.line.me/faq-sellers?utm_source=lineman-sellers#usinglinks"
      >ขั้นตอนการนำลิงก์ไปตั้งค่าริชเมนู (RICH MENU)</a>
    </div>
    <div class="copy-container">
      <div class="title">สำหรับช่องทางโซเชียลมีเดีย</div>
      <div class="url-container">
        <div class="url volte weight-500">
          <textarea rows="1" disabled>{{generateAppLink(data.links.app, data.restaurantId)}}</textarea>
        </div>
        <div 
          class="button volte weight-600 desktop-only"
          v-on:click="copyLink('app')"
        >Copy</div>
      </div>
      <div 
        class="button volte weight-600 mobile-only"
        v-on:click="copyLink('app')"
      >Copy</div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      data: [Object],
    },
    methods: {
      generateAppLink: function(link, id) {
        const baseUrl = 'https://lineman.onelink.me/1N3T';
        const wongnai = `https://www.wongnai.com/delivery/businesses/${id}/order`;
        const params = {
          pid: 'lineman_web',
          c: 'restaurant_share',
          af_channel: 'lineman_sellers',
          af_dp: encodeURIComponent(link),
          af_web_dp: encodeURIComponent(wongnai),
          is_retargeting: 'true',
          af_reengagement_window: '7d',
        };
        const param = Object.keys(params).map(key => key + '=' + params[key]).join('&');
        return `${baseUrl}?${param}`;
      },
      copyLink: function(type) {
        let url = this.data.links[type];
        if (type === 'app') {
          url = this.generateAppLink(url, this.data.restaurantId);
          window.gtag('event', 'copy', {
            event_category: 'button',
            event_label: 'mobileDeepLink'
          });
        }
        else {
          window.gtag('event', 'copy', {
            event_category: 'button',
            event_label: 'liffLink'
          });
        }
        const textarea = document.createElement("textarea");
        textarea.style.position = 'fixed';
        textarea.style.top = 0;
        textarea.style.left = 0;
        textarea.style.opacity = 0;
        textarea.value = url;
        document.body.appendChild(textarea);
        textarea.focus();
        textarea.select();
        try {
          document.execCommand('copy');
          window.dispatchEvent(new CustomEvent('toast', {detail: 'คัดลอกลิงก์เรียบร้อยแล้ว'}));
        } catch (err) {
          window.dispatchEvent(new CustomEvent('toast', {detail: 'Something went wrong'}));
        }
        document.body.removeChild(textarea);
      }
    },
  }
</script>

<style lang="scss" scoped>
  .generate-link {
    .info {
      display: flex;
      margin-bottom: 36px;

      .text {
        color: #666666;
        margin-right: 36px;
        flex: 1;
      }
      .title {
        font-size: 24px;
        color: #000;
        font-weight: 600;
        line-height: 36px;
      }
      .category {
        font-size: 16px;
        margin-bottom: 8px;
        line-height: 36px;
      }
      .address {
        font-size: 14px;
        line-height: 20px;
      }
      .image {
        width: 180px;
        min-width: 180px;
        height: 126px;
        background: lightgray;
        border-radius: 5px;
        object-fit: cover;
        font-family: 'object-fit: cover';
      }
    }

    .copy-container {
      margin: 16px 0 32px 0;

      .title {
        font-size: 18px;
        font-weight: 700;
      }
      .url-container {
        margin: 12px 0;
        display: flex;
        border: 1px solid #dfdfdf;
        justify-content: space-between;
        padding: 8px 8px 8px 20px;
        align-items: center;
        border-radius: 5px;
        height: 60px;
      }
      .url {
        width: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding-right: 16px;

        textarea {
          color: #9b9b9b;
          width: 100%;
          border: none;
          resize: none;
          font-size: 16px;
          line-height: 40px;
          white-space: nowrap;
          overflow-y: hidden;
          cursor: text;
        }
      }
      .button {
        min-width: 96px;
        padding: 0 16px;
        min-height: 40px;
        line-height: 40px;
      }
      .button.mobile-only {
        display: none;
      }
      .link {
        font-weight: 600;
        display: block;
        font-size: 18px;
      }
    }
  }

  @media screen and (max-width: 720px) {
    .generate-link {
      padding: 32px 24px;
      overflow-y: auto;

      .copy-container {
        .url-container {
          padding: 8px 20px;
        }
        .url {
          padding-right: 0;
        }
        .button.mobile-only {
          display: flex;
          margin-bottom: 8px;
        }
        .title {
          font-size: 20px;
        }
      }

      .info {
        .image {
          min-width: 100px;
          width: 100px;
          height: 70px;
        }
        .title {
          margin-bottom: 8px;
          line-height: 36px;
        }
        .category {
          font-size: 14px;
          margin-bottom: 4px;
          line-height: 16px;
        }
        .address {
          line-height: 16px;
        }
      }
    }
  }
  
</style>